import { ITimesheet, IUser } from '@app/common';

export const toTimesheetForm = (timesheet?: Partial<ITimesheet>) => {
  return {
    clockingIn: timesheet?.clockingIn ? new Date(timesheet.clockingIn) : new Date(),
    clockingOut: timesheet?.clockingOut ? new Date(timesheet.clockingOut) : new Date(),
    userId: timesheet?.userId ?? null,
  };
};

export const fromTimesheetForm = (form: ReturnType<typeof toTimesheetForm>, timesheet?: Partial<ITimesheet>) => {
  // Extract _id from user object if it's populated
  const userId = typeof form.userId === 'object' && form.userId !== null 
    ? (form.userId as IUser)._id 
    : form.userId;

  return {
    _id: timesheet?._id,
    clockingIn: form.clockingIn,
    clockingOut: form.clockingOut,
    userId: userId,
  };
};

